import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useState, useCallback } from "react";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { useRemoveWorkspaceReceiptSender } from "@api/workspaceReceiptSender.api";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Menu } from "@design-system/Menu/Menu.lib";

export const ReceiptSenderActionsCell = memo(
    <
        T extends {
            id: string;
            email: string | null;
            phoneNumber: string | null;
        },
    >({
        row,
    }: CellContext<ViewTableFeatures, T, any>) => {
        const sender = row.original;
        const [showConfirmation, setShowConfirmation] = useState(false);
        const removeSender = useRemoveWorkspaceReceiptSender();

        const displayName = sender.email ?? sender.phoneNumber ?? "this sender";

        const handleRemoveClick = useCallback(() => {
            setShowConfirmation(true);
        }, []);

        const confirmRemove = useCallback(() => {
            removeSender.mutate(sender.id);
            setShowConfirmation(false);
        }, [removeSender, sender.id]);

        return (
            <ViewTableCell captureClicks>
                <Menu.More>
                    <Menu.Item destructive onClick={handleRemoveClick}>
                        Remove sender
                    </Menu.Item>
                </Menu.More>

                <ConfirmationModal
                    show={showConfirmation}
                    onHide={() => setShowConfirmation(false)}
                    closeButton
                    title="Remove receipt sender?"
                    question={`Are you sure you want to remove "${displayName}"?`}
                    onConfirm={confirmRemove}
                    onReject={() => setShowConfirmation(false)}
                    yes="Remove"
                    yesBtnVariant="destructive"
                    no="Cancel"
                />
            </ViewTableCell>
        );
    },
);
